import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface citiesState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: citiesState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const citiesSlice = createSlice({
  name: 'cities',
  initialState,
  reducers: {
    setCities: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewCities: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setCities, addNewCities, reset } = citiesSlice.actions;
export const getCities = (state: RootState) => state.cities.data;
export const addCities = (state: RootState) => state.cities.data;
export const getCitiesTotalRecord = (state: RootState) => state.cities.totalRecords;

export default citiesSlice.reducer;
